import { Ref } from 'react';

import { ResponseStatus } from '@revenuemarket/http';
import { Toast } from '@revenuemarket/ui';
import { InputRef } from 'antd';

import { useUpdateCustomLabel } from '~hooks/queries/custom-labels/query';
import { useDemoAwareCompanyId } from '~hooks/useDemoAwareCompanyId';
import { MIXPANEL_EVENT } from '~libs/mixpanel/event';
import { mixpanel } from '~pages/_app';

import NameInput from './common/component/NameInput';

interface InputProps {
  id: number;
  name: string;
  description?: string;
  parentId: number | null;
  inputRef?: Ref<InputRef>;
}

export const CATEGORY_NAME_MAX_LENGTH_INFO = '20자 까지만 입력할 수 있어요.';
export const CATEGORY_NAME_MAX_LENGTH = 20;

const GroupNameInput: React.FC<InputProps> = ({ name, id, description, parentId, inputRef }) => {
  const { companyId } = useDemoAwareCompanyId();
  const { mutateAsync: updateCustomLabel, isLoading } = useUpdateCustomLabel();

  const onSave = async (nameInput: string) => {
    const response = await updateCustomLabel({
      companyId,

      id,
      name: nameInput,
      description: description ?? '',
    });
    if (response.Status === ResponseStatus.SUCCESS) {
      Toast.success('그룹 이름이 변경되었습니다.');
      mixpanel.track(MIXPANEL_EVENT.GROUP.CHANGE_GROUP_NAME);
      mixpanel.track(MIXPANEL_EVENT.ENGAGEMENT.DEFAULT, {
        type: 'CHANGE_GROUP_NAME',
      });
    } else {
      Toast.error('그룹 이름 변경에 실패했습니다.');
    }
  };

  return <NameInput inputRef={inputRef} name={name} isLoading={isLoading} onSave={onSave} />;
};

export default GroupNameInput;
